<!--
 * @Author: Ashley.Liu
 * @Date: 2022-11-30 16:58:14
 * @LastEditTime: 2023-01-11 09:56:11
 * @Description: desc
-->
<template>
  <span
    class="as-copy-button"
    :class="[position]"
    :style="{ '--svgSize': `${fontSize}px` }"
  >
    <zm-tooltip
      v-if="type !== 'text'"
      :content="success ? 'Copied' : 'Copy'"
      effect="dark"
      placement="top"
    >
      <zm-button
        ghost
        @click.stop.prevent="copyContent"
        :class="[
          'as-copy-button__copy',
          success && 'as-copy-button__copy-success',
        ]"
      >
        <Copy class="as-copy-button__svg" v-show="!success"></Copy>
        <i
          v-show="success"
          class="zm-icon-corner-success"
          :style="`font-size: ${fontSize}px`"
        ></i>
      </zm-button>
    </zm-tooltip>
    <zm-button
      v-else
      ghost
      @click.stop.prevent="copyContent"
      :class="['as-copy-button__copy']"
    >
      {{ !success ? 'Copy' : 'Copy Success' }}
    </zm-button>
  </span>
</template>

<script>
import Copy from '../../assets/svg/Copy.svg'
export default {
  name: 'AsCopy',
  components: {
    Copy,
  },
  props: {
    content: [String, Object],
    fontSize: {
      type: Number,
      default: 14,
    },
    position: String,
    type: {
      type: String,
      default: 'icon',
    },
  },
  data() {
    return {
      success: false,
    }
  },
  mounted() {},
  destroyed() {
    this.timer && clearTimeout(this.timer)
  },
  methods: {
    copyContent() {
      let content = this.content
      if (
        Array.isArray(this.content) ||
        Object.prototype.toString.call(this.content) === '[object Object]'
      ) {
        content = JSON.stringify(this.content, null, 2)
      }
      this.$copyText(content).then(() => {
        this.success = true
        this.timer = setTimeout(() => {
          this.success = false
        }, 2000)
      })
    },
  },
}
</script>

<style lang="scss">
.as-copy-button {
  display: inline-block;

  .as-copy-button__copy {
    padding: 0;
    display: inline-block;
  }
  &__svg {
    vertical-align: top;
    width: var(--svgSize);
    height: var(--svgSize);
  }
}
// for table cell
.as-copy-button.center {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto 0;
  .as-copy-button__copy {
    vertical-align: top;
  }
}
.as-copy-button.relative {
  margin-left: 8px;
}

// for code block
.as-copy-button.right {
  position: absolute;
  box-sizing: content-box;
  right: var(--svgSize);
  top: 8px;
  @mixin background-default {
    background-color: transparent;
    border-color: transparent;
  }
  @mixin background-hover {
    background-color: #dfe3e8;
    border-color: #dfe3e8;
  }
  @mixin background-active {
    background-color: #c1c6ce;
    border-color: #c1c6ce;
  }
  @mixin background-success {
    background-color: transparent;
    border-color: transparent;
  }
  .as-copy-button__copy {
    padding: 8px;
    background-color: #f1f4f6;
    border-color: #f1f4f6;
    &:hover {
      @include background-hover;
    }
    &:active {
      @include background-hover;
    }
  }

  .as-copy-button__copy.as-copy-button__copy-success {
    @include background-success;
    &:hover {
      @include background-success;
    }
  }
}
</style>
